import { render } from "./over-avatars.vue?vue&type=template&id=e5afb1d8&ts=true"
import script from "./over-avatars.vue?vue&type=script&lang=ts"
export * from "./over-avatars.vue?vue&type=script&lang=ts"

import "./over-avatars.vue?vue&type=style&index=0&id=e5afb1d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__